export default __webpack_public_path__ + "static/media/Code-Quiz-img-1.a193c3b7.jpg";